import { api, getSessionId } from "./api";

export function getVisitorId() {
  let vid = localStorage.getItem("fantini_visitor");
  if (!vid) {
    vid = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("fantini_visitor", vid);
  }
  return vid;
}

export function track(type, extra = {}) {
  if (window.location.pathname.startsWith("/admin")) return;
  api.post("/track", {
    type, path: window.location.pathname, referrer: document.referrer || "",
    visitor_id: getVisitorId(), session_id: getSessionId(), ...extra,
  }).catch(() => {});
}
